import { StreamActions } from "@hotwired/turbo"

StreamActions.alert = function () {
  alert(this.getAttribute("text"));
}
